<template>
  <header v-test:header="'plans and rate attributes'">
    <div>
      <h2><slot /></h2>
      <h3 v-if="$slots.subtitle">
        <slot name="subtitle" />
      </h3>
      <p v-if="description">
        <template v-if="description.length > 200">
          {{ description.substr(0, 200) }}&hellip;
          <tf-button
            class="btn-full-description"
            type="primary"
            size="text"
            @click="$emit('clickDescription')"
            v-text="'full description'"
          />
        </template>
        <template v-else>
          {{ description }}
        </template>
      </p>
    </div>
    <div>
      <tf-button
        v-test:button="'toggle'"
        :class="[
          { 'is-active': value },
          'btn-toggle'
        ]"
        icon="chevron-up"
        size="icon-no-fill"
        type="primary"
        no-border
        @click="$emit('input', !value)"
      />
    </div>
  </header>
</template>

<script>
  /**
   * A component used for Plan Design and Rate Entry sections.
   *
   * @vuedoc
   * @exports PlanAndRateHeader
   * @category Components
   */
  export default {
    name: 'PlanAndRateHeader',
    props: {
      description: {
        type: String,
        default: '',
      },
      value: {
        type: Boolean,
        required: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  header {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 18px 20px;
    border: 1px solid $tf-light-gray;
    border: {
      radius: 6px 6px 0 0;
    }
  }

  h2 {
    margin-bottom: 0;
  }

  .tf-button.btn-full-description {
    margin-top: 5px;
  }

  .btn-toggle {
    transition: transform .3s ease-out;

    &.is-active {
      transform: rotate(180deg);
      fill: $tf-blue;
    }
  }

</style>
